import { Component } from '@angular/core';
import { NavController, Platform, AlertController, LoadingController } from 'ionic-angular';
import { YoutubeProvider } from './../../providers/youtube';
import { YoutubeVideoPlayer } from '@ionic-native/youtube-video-player';
import { Observable } from 'rxjs/Observable';

@Component({
	selector: 'page-video',
	templateUrl: 'video.html',
})

export class VideoPage {

	channelId = 'UCK4c-gfya5k0Qej8w-l3Lhg'; // Devdactic Channel ID
	playlists: Observable<any>;
	videos: Observable<any[]>;
	videoList: any;
	displayData:boolean = false;

	constructor(
		public navCtrl: NavController,
		private ytProvider: YoutubeProvider,
		private alertCtrl: AlertController,
		private loadingCtrl: LoadingController,
		private youtube: YoutubeVideoPlayer,
		private plt: Platform) { }
		

	ionViewDidLoad() {
		let loader = this.loadingCtrl.create();
		loader.present().then(() => {
			this.playlists = this.ytProvider.getPlaylistsForChannel(this.channelId);

			this.playlists.subscribe(data => {
				console.log(data);

				if (data) {
					let listId = data[0].id;
					this.videos = this.ytProvider.getListVideos(listId);

					this.videos.subscribe(data => {
						this.videoList = data;
						this.displayData = true;
						console.log(data)
					});
					console.log(this.videos);
				}
				loader.dismiss();
			}, err => {
				let alert = this.alertCtrl.create({
					title: 'Error',
					message: 'No Playlists found for that Channel ID',
					buttons: ['OK']
				});
				alert.present();
				loader.dismiss();
			})
		});
	}


	openVideo(video) {
		if (this.plt.is('cordova')) {
			this.youtube.openVideo(video.snippet.resourceId.videoId);
		} else {
			window.open('https://www.youtube.com/watch?v=' + video.snippet.resourceId.videoId);
		}
	}

	
}



// WEBPACK FOOTER //
// ./src/pages/video/video.ts